
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/awards",
      function () {
        return require("private-next-pages/about-us/awards/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/awards"])
      });
    }
  